export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/fintp/cat',
		name: 'NbuFintpCat',
		title: {
			single: 'NbuFintpCat',
			plural: 'NbuFintpCats'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "R",
				"code": null,
				"name": "Державний реєстр фінансових установ",
				"caption": "Державний реєстр фінансових установ",
				"isBlocked": false
			},
			{
				"id": "C",
				"code": null,
				"name": "Ядро",
				"caption": "Ядро",
				"isBlocked": false
			},
			{
				"id": "I",
				"code": null,
				"name": "Реєстр страхових посередників",
				"caption": "Реєстр страхових посередників",
				"isBlocked": false
			}
		],
	},
}
